var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<a href=\"#\" style=\"display: block;\" ng-click=\"promptAcceptApplication(application)\" ng-disabled=\"application.status != 'S'\" ng-if=\"application.landlord_can_edit &amp;&amp; application.show_accept_reject_button\" class=\"fancybox-modal2 accept\">Approve</a>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/acceptRejectApplication/acceptApplication/acceptApplication.jade
// module id = 480
// module chunks = 0